export default __webpack_public_path__ + "static/media/bonusBox_open.2598cf05.webp";